export default __webpack_public_path__ + "static/media/logo.f27f068e.svg";